/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import { FormattedMessage } from "react-intl";
import TravelerContent from "./content/travelerContent.js";

/* Styles */
import styles from "./styles.js";

const Content = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.modalContent}>
      <div className={classes.contentWrapper}>
        <h3>
          <FormattedMessage id="acTermsModal.traveler.title" />
        </h3>
        <p>
          <FormattedMessage id="acTermsModal.traveler.description" />
        </p>
        <TravelerContent />
      </div>
    </div>
  );
};

export default Content;
